export default __webpack_public_path__ + "static/media/Mayor.e45ec070.png";